import { render, staticRenderFns } from "./RubberBand.vue?vue&type=template&id=afa37144&"
import script from "./RubberBand.vue?vue&type=script&lang=js&"
export * from "./RubberBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports